import moment from "moment";

/**
 * @param {string} startDate - Fecha de inicio formato YYYY-MM-DD
 * @param {string} endDate - Fecha de fin formato YYYY-MM-DD
 * @returns {Array} - Array de fechas entre startDate y endDate
 */
export default function getDateArrayBetweenDates(startDate, endDate) {
    const dateArray = [];
    let currentDate = moment(startDate);
    let stopDate = moment(endDate);
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
} 